import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

type Props = {
	input: string;
};

export function EmptyResult({ input }: Props): JSX.Element {
	return (
		<div className="text-center">
			<Text variant="body" fontWeight="bold" className="text-primary-changeRed underline">
				<Translate
					value="corgi.petition.edit.petition_data.decision_maker.create_dm"
					replacements={{ dm_name: input }}
				/>
			</Text>
		</div>
	);
}
